export const BASE = {
  '--app-primary-color': '#830051',
  '--app-secondary-color': '#4d0030',
  '--app-tertiary-color': '#ebefee',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': '#4d0030',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': '#fbfbfbff',
  '--sidebar-active-text-color': '#830051'
};

export const FUCAM = {
  '--app-primary-color': '#e24c6a',
  '--app-secondary-color': '#2A030B',
  '--app-tertiary-color': '#ebefee',
  '--app-disabled-color': 'hsl(220, 12%, 95%)',
  '--sidebar-bg-color': '#e24c6a',
  '--sidebar-icon-color': 'hsl(0, 0%, 100%)',
  '--sidebar-text-color': 'hsl(0, 0%, 100%)',
  '--sidebar-active-bg-color': '#78192C',
  '--sidebar-active-text-color': 'hsl(0, 0%, 100%)'
};
